{
	"accept_invite": {
		"description": "Imposta una password per completare l'attivazione del tuo account.",
		"invalid_link_description": "Contatta il tuo amministratore per richiedere un nuovo invito.",
		"invalid_link_title": "Link di invito non valido",
		"submit": "Attiva account",
		"success": "Account attivato: sei entrato nel gestionale.",
		"title": "Attiva il tuo account"
	},
	"aside": {
		"description": "Bandi, domande e graduatorie delle residenze universitarie, in un solo posto.",
		"title": "Gestionale Unicasa"
	},
	"back_to_login": "Torna all'accesso",
	"confirm_password": "Conferma password",
	"cooldown": "Reinvia tra {{seconds}}s",
	"email_placeholder": "Inserisci il tuo indirizzo email",
	"forgot_password": {
		"description": "Inserisci l'indirizzo email del tuo account e ti invieremo un link per reimpostare la password.",
		"email_sent_description": "Controlla la tua email e segui le istruzioni per reimpostare la password.",
		"email_sent_title": "Email inviata",
		"resend": "Invia di nuovo",
		"submit": "Invia link di reimpostazione",
		"title": "Password dimenticata?"
	},
	"log_in": "Accedi",
	"login": {
		"description": "Inserisci la tua email per accedere al tuo account",
		"forgot_password": "Password dimenticata?",
		"locked_until": "Troppe password sbagliate: account bloccato fino alle {{time}}.",
		"remember": "Ricordami per 7 giorni (solo gestori di struttura)",
		"sso_error": "Accesso non riuscito. Riprova.",
		"title": "Accedi al tuo account"
	},
	"reset_password": {
		"description": "Scegli una password sicura per proteggere il tuo account",
		"invalid_token": "Questo link di reimpostazione password non è valido o è scaduto.",
		"request_new_link": "Richiedi un nuovo link di reimpostazione",
		"submit": "Reimposta password",
		"title": "Imposta una nuova password"
	},
	"validation": {
		"email_invalid": "Inserisci un indirizzo email valido.",
		"password_invalid": "Inserisci una password valida.",
		"passwords_mismatch": "Le password non corrispondono."
	}
}
